import React from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Typography } from '@lyearn/ui';

import { FormFieldTitle } from '../types';

function Title(props: FormFieldTitle) {
  const { t } = useTranslation();

  return (
    <Typography className="mb-8 flex items-center ps-8" variant="heading-s">
      {props.children}
      {props.optional ? (
        <Typography className="ms-4" color="text-text-placeholder" variant="body-short-02">
          ({t('Common:Form.optional')})
        </Typography>
      ) : null}
    </Typography>
  );
}

export default Title;
